import { Grid } from '@material-ui/core';
import ToolTip from '@material-ui/core/Tooltip';
import Icon from '../../Icon';
import Handle from '../../Handler';
import './style.css';
import { makeStyles } from '@material-ui/core/styles';
import helpers from '../../../helpers';
import { nodeKeysLabel } from "../../../../../../../config/common";
import { useDispatch, useSelector } from 'react-redux';
import { getRightDrawerStatus } from '../../../../../../../store/global/selectors';
import { setFocusElement, toggleRightDrawer } from '../../../../../../../store/global/actions';
import NodeHelperPopup from '../../../../../dialogs/NodeHelperPopup';

const useStyles = makeStyles({
    image: {
        width: 100,
        height: 100,
        display: 'block',
        position: 'relative',
        top: 0,
        left: 0,
        marginTop: 38
    },
    label: {
        textAlign: 'center',
        display: 'block',
        fontSize: 17,
        fontFamily: 'Roboto, Helvetica',
        fontWeight: 500
    },
    desc: {
        textAlign: 'center',
        display: 'block',
        fontSize: 12,
        fontFamily: 'Roboto, Helvetica',
        fontWeight: 400
    },
    labelDiv: {
        marginTop: "160px",
        pointerEvents: 'all'
    }
})


export default function Delegate({ props, validations, iconStyle }) {
    const nodeData = props.data != undefined ? props.data : '';
    const title = props?.data?.subType !== undefined && props?.data?.subType !== '' ? nodeKeysLabel[props?.data?.subType] : helpers.nodeKeysLabel[props.type];
    const nodeTitle = props?.data?.label || null;
    const classes = useStyles()
   
    return (
        <Grid row id={`node-${props?.id}`}>
            <Grid item xs={12} style={{pointerEvents: 'all'}}>
                {/* <ToolTip title={<>{nodeData?.label}<br />{`(${title})`}</>} placement="bottom"> */}
                    <div className='node-box delegate-node-box'>
                        {/* <img src={`${process.env.PUBLIC_URL}/node_icons/ide_delegate.png`} className={classes.image} />    */}
                        <Icon icon={null} iconPath={'delegate_icons'} defaultIcon={'ide_delegate_inner_default'} className={classes.iconImage} style={iconStyle} />
                    </div>
                {nodeData?.showHelper && <NodeHelperPopup nodeData={nodeData} title={title} nodeId={props.id} nodeType={props.type} subType={props?.data?.subType} templateId={props?.templateId} />}
                    
                {/* </ToolTip> */}
            </Grid>
            <Grid item xs={12} className={classes.labelDiv}>
                <span className={classes.label}>{props.data.label}</span>
                {props.data.protocolDesc && <span className={classes.desc}>{props.data.protocolDesc}</span>}
            </Grid>

            <Handle type="source" node="external_function" position="left" isValidConnection={validations('target', 'external_function')} id="left" node={props}/>

            <Handle type="source" node="external_function" position="right" isValidConnection={validations('source', 'external_function')} id="right" node={props}/>

        </Grid>
    )
}